import React from 'react';
import styled, { keyframes } from 'styled-components';

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-250px * 7)); }
`;

const MarqueeContainer = styled.div`
  background: var(--bg-secondary);
  padding: 3rem 0;
  border-top: 1px solid var(--border-subtle);
  border-bottom: 1px solid var(--border-subtle);
  overflow: hidden;
  position: relative;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    width: 250px;
    height: 100%;
    z-index: 2;
  }
  
  &::before {
    left: 0;
    background: linear-gradient(to right, var(--bg-secondary) 0%, transparent 100%);
  }
  
  &::after {
    right: 0;
    background: linear-gradient(to left, var(--bg-secondary) 0%, transparent 100%);
  }
`;

const MarqueeTitle = styled.h3`
  text-align: center;
  color: var(--text-tertiary);
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  margin-bottom: 2rem;
`;

const MarqueeTrack = styled.div`
  display: flex;
  width: calc(250px * 14);
  animation: ${scroll} 40s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

const LogoBox = styled.div`
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 1.2rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: var(--accent-primary);
  }

  img {
    height: 40px;
    width: auto;
    filter: grayscale(100%) opacity(0.7);
    transition: all 0.3s ease;
  }

  &:hover img {
    filter: grayscale(0%) opacity(1);
  }
`;

const TechStackMarquee = () => {
    const techLogos = [
        { name: 'React', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
        { name: 'Node.js', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
        { name: 'Python', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg' },
        { name: 'TensorFlow', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg' },
        { name: 'PyTorch', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg' },
        { name: 'AWS', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg' },
        { name: 'Docker', url: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg' },
    ];

    // Double the array to create the infinite scroll effect seamlessly
    const scrollItems = [...techLogos, ...techLogos];

    return (
        <MarqueeContainer>
            <MarqueeTitle>Powered by Industry-Leading Technology</MarqueeTitle>
            <MarqueeTrack>
                {scrollItems.map((tech, index) => (
                    <LogoBox key={index}>
                        <img src={tech.url} alt={`${tech.name} logo`} />
                        <span style={{ display: tech.name === 'AWS' ? 'none' : 'block' }}>{tech.name}</span>
                    </LogoBox>
                ))}
            </MarqueeTrack>
        </MarqueeContainer>
    );
};

export default TechStackMarquee;
